import styled from "styled-components"

export const MobileTableDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
